import get from 'lodash/get';
import {
  FETCH_AD_START,
  FETCH_AD_SUCCESS,
  FETCH_AD_FAILED,
  CHANGE_AD_PAGE,
  SAVE_APPLY_START,
  SAVE_APPLY_SUCCESS,
  SAVE_APPLY_FAILED,
  FETCH_RELATED_ADS_START,
  FETCH_RELATED_ADS_SUCCESS,
  FETCH_RELATED_ADS_FAILED,
  NAVIGATE_AD_PAGE,
  ENABLE_RELATED_ADS_FETCH,
} from './constants';
import defaultState from '../state';

const adPageInitialState = get(defaultState, 'adPage');

export default (state = adPageInitialState, action) => {
  switch (action.type) {
    case FETCH_AD_START:
      return {
        ...state,
        isFetching: true,
        error: null,
      };

    case FETCH_AD_SUCCESS:
      return {
        ...state,
        isFetching: false,
        ad: action.ad,
        error: null,
      };

    case FETCH_AD_FAILED:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    case CHANGE_AD_PAGE:
      return {
        ...state,
        applyError: null,
        error: null,
        ad: action.ad,
      };

    case SAVE_APPLY_START:
      return {
        ...state,
        isSendingApply: true,
        applyError: null,
      };

    case SAVE_APPLY_SUCCESS:
      return {
        ...state,
        isSendingApply: false,
        adsContacted: state.adsContacted.concat(action.data.adId),
        applyError: null,
      };

    case SAVE_APPLY_FAILED:
      return {
        ...state,
        isSendingApply: false,
        applyError: action.error,
      };

    case FETCH_RELATED_ADS_START:
      return {
        ...state,
        error: null,
      };

    case FETCH_RELATED_ADS_SUCCESS:
      return {
        ...state,
        relatedAds: action.res,
      };

    case FETCH_RELATED_ADS_FAILED:
      return {
        ...state,
        error: action.error,
        relatedAds: [],
      };

    case NAVIGATE_AD_PAGE: {
      const currentAd = state.ad;
      const relatedAds = state.relatedAds
        .map(ad => {
          if (ad.position === action.ad.position) {
            return currentAd;
          }
          return ad;
        })
        .sort((a, b) => a.position - b.position);
      return {
        ...state,
        isRelatedAdsFetchEnabled: false,
        relatedAds,
        ad: action.ad,
      };
    }

    case ENABLE_RELATED_ADS_FETCH:
      return {
        ...state,
        isRelatedAdsFetchEnabled: action.isEnabled,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/AdPage/reducer.js